<!-- <form [formGroup]="containerMasterForm" id="form" (ngSubmit)="submitForm()"> -->


<div [classList]="Canvas">
    <div #mySidepanel [classList]="open">
        <div class="form1">
            <div fxLayout="column wrap">
                <div class="headContent">
                    <span class="head"> <b> Introductory Details</b></span>
                    <i id="closeX" (click)="closeDepotForm()" class="flaticon-close delete"></i>
                </div>
                <app-depot-form [depotObject]="selectedDepot" (depotAdded)="bindDepot($event)" [bindName]="bindName"
                    (close)="closeDepotSidePanel()">
                </app-depot-form>
            </div>
        </div>
    </div>
</div>

<button class="edit" color="primary" mat-fab (click)="editableToggle()" *ngIf="containerObj.id" cdkDrag>
    <i MatSuffix id="i1" class="flaticon-{{isEditable? 'save': 'pencil-tool'}}"></i>
</button>
<cdk-custom-stepper class="relaxed" id="customStepper" #badStepper>
    <div id="form">
        <cdk-step>
            <ng-template cdkStepLabel>Container Information</ng-template>
            <span class="containerNo">Container No: {{containerObj.container_number}}</span>
            <div class="proBg">
                <mat-progress-bar id="progressBar" class="progressSlider" mode="determinate" value="{{counter}}">
                </mat-progress-bar>
            </div>
            <!-- <form id="form"> -->
            <!-- <app-depot-form></app-depot-form> -->
            <div class="formLayout">
                <div class="content form-group" id="card1" fxLayout="column wrap" *ngIf="!loader">

                    <div class="headContent ownership">
                        <button mat-icon-button (click)="backToList()" class="backArrow">
                            <i class="flaticon-back-arrow"></i>
                        </button>
                        <span class="head ownership">
                            <b>Ownership Detail</b>
                            <ng-container *ngIf="containerObj.id">
                                <ng-container *ngIf="containerMasterService.latestBlockForCompany?.blocked_for_company==null">
                                    <mat-chip>{{containerMasterService.latestBlockForCompany?.status?.name}}</mat-chip>
                                    <mat-chip (click)="redirectToRequest(containerMasterService.latestBlockForCompany?.request)">{{containerMasterService.latestBlockForCompany?.request?.request_number}}</mat-chip>
                                    <!-- <mat-chip *ngIf="bookingDetails != null && bookingDetails?.old_booking_number">OBN:
                                        {{bookingDetails?.old_booking_number}}</mat-chip> -->
                                    <mat-chip *ngIf="containerMasterService.latestBlockForCompany?.current_location?.name_display">
                                        {{containerMasterService.latestBlockForCompany?.current_location?.name_display}}
                                    </mat-chip>
                                </ng-container>
                                <ng-container *ngIf="containerMasterService.latestBlockForCompany?.blocked_for_company!=null">
                                    <!-- <mat-chip>
                                        Blocked
                                    </mat-chip>
                                    <mat-chip>
                                        {{containerMasterService.latestBlockForCompany?.blocked_for_company?.legal_name}}
                                    </mat-chip>
                                    <mat-chip (click)="redirectToRequest(containerMasterService.latestBlockForCompany?.blocked_for_request)">
                                        {{containerMasterService.latestBlockForCompany?.blocked_for_request?.request_number}}
                                    </mat-chip> -->
                                    <span fxLayout="row" class="gap-1 align-items-center">Allocated For <mat-chip>
                                        {{containerMasterService.latestBlockForCompany?.blocked_for_company?.legal_name}}
                                        </mat-chip> against request no. <mat-chip
                                            (click)="redirectToRequest(containerMasterService.latestBlockForCompany?.blocked_for_request)">
                                            {{containerMasterService.latestBlockForCompany?.blocked_for_request?.request_number}}
                                        </mat-chip>
                                    </span>
                                </ng-container>
                            </ng-container>
                        </span>
                        <span *ngIf="containerObj.id" class="lastActivity">Last activity date:
                            <mat-chip>{{containerObj?.last_activity_date | date:'dd MMM, yyyy'}}</mat-chip>
                        </span>
                    </div>
                    <div class="formContent" fxLayout="column wrap">
                        <!-- Post Ownership ID -->

                        <app-toggle-select
                            [isEditable]="isEditable && (isNotEditable || containerObj.lifecycle.status_type == 0)"
                            [label]="'What is your ownership of the container?*'" [(ngModel)]="containerObj.ownership"
                            [name]="'ownership'" [options]="containerOwnershipList?.results" [displayField]="'value'"
                            (ngModelChange)="onOwnershipChange()" [errors]="errorObj.ownership" fxLayout="column wrap"
                            [class.margin]="isEditable">
                        </app-toggle-select>
                        <div class="quantity" fxFlex="100">
                            <span>Method of adding Container(s) in system</span>
                        </div>
                        <div class="btn" [class.set]="isEditable" fxFlex="100">
                            <ng-container *ngIf="isEditable && isNotEditable">
                                <mat-button-toggle-group [(ngModel)]="containerObj.insert_mode">
                                    <mat-button-toggle [value]="2000" (click)="hide()">Bulk Upload
                                    </mat-button-toggle>
                                    <mat-button-toggle [value]="1000" (click)="show();">Single
                                        Container
                                    </mat-button-toggle>
                                </mat-button-toggle-group>
                            </ng-container>
                            <ng-container *ngIf="!isEditable || !isNotEditable">
                                <div class="viewLable">
                                    <span>
                                        {{containerObj.insert_mode==1000?'Single Container Entry':'Bulk Entry'}}</span>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </div>
                <logzy-content-loader *ngIf="loader" [set1]="loader"></logzy-content-loader>
                <logzy-content-loader *ngIf="loader" [set2]="loader"></logzy-content-loader>
                <logzy-content-loader *ngIf="loader" [set2]="loader"></logzy-content-loader>
                <div *ngIf="isShown">
                    <div *ngIf="showProcurement">
                        <div class="content form-group" id="card2" fxLayout="column wrap" *ngIf="!loader">
                            <div class="headContent fhc" fxFlex="100">
                                <span class="head">
                                    <b>Procurement Details</b>
                                </span>
                            </div>
                            <div fxFlex="100" class="inputs inputMaxWidth" fxLayout="row wrap">
                                <!-- Post PO Number -->
                                <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                                    <div class="inputTitle">
                                        <span>PO No <i MatSuffix
                                                matTooltip="All the trading supply Confirmed deals would be shown in the dropdown."
                                                matTooltipPosition="right" [matTooltipHideDelay]="2000" id="i1"
                                                class="flaticon-message"></i></span>
                                    </div>
                                    <app-mat-auto-search [isEditable]="isEditable" [name]="'po_number'"
                                        [ngModel]="containerObj.purchase_order"
                                        (ngModelChange)="onPONumberSelect($event)"
                                        [listUrl]="container_url+'trade_agreement_number/?search=::search::'"
                                        [displayField]="'request_number'" [idField]="null"
                                        [labelItemTemplate]="poSelectedItem" [itemTemplate]="poItem"
                                        [displayTemplate]="poDisplayItem">
                                    </app-mat-auto-search>
                                </div>

                                <!-- Post invoice id -->
                                <!-- [(ngModel)]="containerObj.invoice_number" [listUrl]="country_url+'country/?name=::search::'" -->
                                <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                                    <div class="inputTitle">
                                        <span>Invoice No</span>
                                    </div>
                                    <app-text-field [isEditable]="isEditable" [name]="'invoice_number'" [(ngModel)]="containerObj.invoice_number">
                                    </app-text-field>
                                </div>

                                <!-- Post Vendor Name -->
                                <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                                    <div class="inputTitle">
                                        <span>Vendor Name</span>
                                    </div>
                                    <app-text-field [isEditable]="isEditable" [(ngModel)]="containerObj.vendor_name"
                                        [minlength]="3" [name]="'vendor_name'" [errors]="errorObj.vendor_name">
                                    </app-text-field>
                                </div>

                                <!-- Post Invoice date with respect to Invoice id -->
                                <!-- [(ngModel)]="containerObj.invoice_date" -->
                                <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                                    <div class="inputTitle">
                                        <span>Invoice Date</span>
                                    </div>
                                    <app-date-field [isEditable]="isEditable" [(ngModel)]="containerObj.invoice_date" [name]="'invoice_date'">
                                    </app-date-field>
                                </div>

                                <!-- Post urchase price and currency format -->
                                <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                                    <div class="inputTitle">
                                        <span>Purchase Price*</span>
                                    </div>
                                    <logzy-money-field [isEditable]="isEditable"
                                        [(amount)]="containerObj.purchase_price"
                                        [(currencyCode)]="containerObj.purchase_price_currency"
                                        [errors]="errorObj.purchase_price">
                                    </logzy-money-field>
                                </div>

                                <!-- Post Portal Name of where container was procured from -->
                                <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                                    <div class="inputTitle">
                                        <span>Procured from portal</span>
                                    </div>
                                    <app-select-field [isEditable]="isEditable" [(ngModel)]="containerObj.procured_from"
                                        [name]="'procured_from'" [displayField]="'value'"
                                        [options]="containerProcurePortalList?.results" [idField]="null"
                                        [errors]="errorObj.procured_from">
                                    </app-select-field>
                                </div>

                            </div>
                        </div>

                    </div>
                    <div *ngIf="showLease">
                        <div class="content form-group" id="card2" fxLayout="column wrap" *ngIf="!loader">
                            <div class="headContent fhc" fxFlex="100">
                                <span class="head">
                                    <b>Lease Details</b>
                                </span>
                            </div>
                            <div>
                                <span style="color:red">{{errorObj.lease_agreement}}</span>
                            </div>
                            <!-- <div *ngIf="containerObj.lease_agreement == null"class="inputs inputMaxWidth">
                                <span>No data in Lease Details </span>
                            </div> -->
                            <ng-container *ngIf="containerObj.lease_agreement!=null">
                                <div fxFlex="100" class="inputs inputMaxWidth" fxLayout="row wrap">

                                    <!-- Post Lease no -->
                                    <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                                        <div class="inputTitle">
                                            <span>Lease No*</span>
                                        </div>
                                        <app-mat-auto-search [isEditable]="isEditable"
                                            [ngModel]="containerObj?.lease_agreement" [name]="'agreement_number'"
                                            (ngModelChange)="getLease($event)"
                                            [listUrl]="container_url+'lease_agreement_number/?search=::search::'"
                                            [descriptiveLabel]="containerObj.lease_agreement?.lease_type"
                                            [secondaryLabel]="'Type: '" [displayField]="'agreement_number'"
                                            [idField]="null" [labelItemTemplate]="leaseSelectedItem"
                                            [itemTemplate]="leaseItem" [displayTemplate]="leaseDisplayItem"
                                            [errors]="errorObj.lease">
                                        </app-mat-auto-search>
                                    </div>

                                    <!-- Post Lease Start Date -->
                                    <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                                        <div class="inputTitle">
                                            <span>Lease Start Date</span>
                                        </div>
                                        <app-date-field [isEditable]="isLeaseEditable" [name]="'agreement_starts_from'"
                                            [(ngModel)]="containerObj.lease_agreement.agreement_starts_from">
                                        </app-date-field>
                                    </div>

                                    <!-- Post Lease Start Date -->
                                    <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                                        <div class="inputTitle">
                                            <span>Lease End Date</span>
                                        </div>
                                        <app-date-field [isEditable]="isLeaseEditable" [name]="'agreement_ends_on'"
                                            [(ngModel)]="containerObj.lease_agreement.agreement_ends_on">
                                        </app-date-field>
                                    </div>

                                    <!-- Post Vendor Name -->
                                    <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                                        <div class="inputTitle">
                                            <span>Vendor Name</span>
                                        </div>
                                        <app-text-field [isEditable]="isLeaseEditable"
                                            [(ngModel)]="containerObj.lease_agreement.lessor_company_name"
                                            [name]="'lessor_company_name'">
                                        </app-text-field>
                                    </div>

                                    <!-- Post Type of Lease -->
                                    <!-- <app-select-field [isEditable]="isLeaseEditable" [label]="'Type of Lease'"
                                [name]="'lease_type'" [(ngModel)]="containerObj.lease.lease_type"
                                [displayField]="'value'" [idField]="null" [options]="leaseTypeList?.results"
                                fxFlex="100" fxFlex.gt-md="33%" fxLayout="column">
                            </app-select-field> -->

                                    <!-- Post Contact Person Name -->
                                    <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                                        <div class="inputTitle">
                                            <span>Contact Person Name</span>
                                        </div>
                                        <app-text-field [isEditable]="isLeaseEditable"
                                            [(ngModel)]="containerObj.lease_agreement.lessor_contact_person_name"
                                            [name]="'lessor_contact_person_name'">
                                        </app-text-field>
                                    </div>

                                    <!-- Post Contact Person email_id -->
                                    <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                                        <div class="inputTitle">
                                            <span>Contact Person email</span>
                                        </div>
                                        <app-text-field [isEditable]="isLeaseEditable"
                                            [(ngModel)]="containerObj.lease_agreement.lessor_contact_person_email"
                                            [name]="'lessor_contact_person_email'">
                                        </app-text-field>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </div>
                <div *ngIf="single">
                    <div class="content form-group" id="card3" fxLayout="column wrap" *ngIf="!loader">
                        <div class="headContent fhc" fxFlex="100">
                            <span class="head"><b>Container Information</b></span>
                        </div>
                        <div fxFlex="100" class="inputs inputMaxWidth" fxLayout="row wrap">

                            <!-- Post Container Number -->
                            <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                                <div class="inputTitle">
                                    <span>Container No*</span>
                                </div>
                                <app-edit-suggestion-field [isEditable]="isEditable && isNotEditable"
                                    [name]="'container_number'" [checkFieldValidity]="true"
                                    [(ngModel)]="containerObj.container_number" (onSelect)="editContainer($event)"
                                    (focusOut)="isContainerNumberValid('Container No')"
                                    [listUrl]="container_url+'container_number/?container_number=::search::'"
                                    [displayField]="'container_number'" [errors]="errorObj.container_number">
                                </app-edit-suggestion-field>
                            </div>

                            <!-- Post Container Size And Type -->
                            <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                                <div class="inputTitle">
                                    <span>Size-Type*</span>
                                </div>
                                <ng-container *ngIf="sizeTypeListFromPurchaseOrder.length == 0">
                                    <app-mat-auto-search [isEditable]="isEditable" [ngModel]="containerSizeType"
                                        (ngModelChange)="setContainerSizeType($event)" [name]="'container_size_type'"
                                        [displayField]="'display'" [idField]="null" [searchIcon]="true"
                                        [listUrl]="container_url+'container_size_type/?search=::search::'"
                                        [errors]="errorObj.container_size" class="align-items-center">
                                    </app-mat-auto-search>
                                </ng-container>
                                <ng-container *ngIf="sizeTypeListFromPurchaseOrder.length > 0">
                                    <app-mat-auto-search [isEditable]="isEditable" [ngModel]="containerSizeType"
                                        (ngModelChange)="setContainerSizeTypeFromPO($event)"
                                        [name]="'container_size_type'" [displayField]="'display'" [idField]="null"
                                        [searchIcon]="true" [options]="sizeTypeListFromPurchaseOrder"
                                        [errors]="errorObj.container_size" class="align-items-center">
                                    </app-mat-auto-search>
                                </ng-container>
                            </div>

                            <!-- Post Container Condition -->
                            <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                                <div class="inputTitle">
                                    <span>Condition</span>
                                </div>
                                <app-select-field [isEditable]="isEditable" [(ngModel)]="containerObj.condition"
                                    [name]="'condition'" [displayField]="'value'" [searchable]="true"
                                    [options]="containerConditionList?.results" [idField]="null"
                                    [errors]="errorObj.condition">
                                </app-select-field>
                            </div>

                            <!-- Post Container Purpose -->
                            <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                                <div class="inputTitle">
                                    <span>{{containerPurposeLabel}} </span>
                                     <!-- <i (click)="openDialogue(containerObj.purpose)" class="flaticon-star-fill"></i> -->
                                </div>
                                <app-toggle-select class="inputToggle" [isEditable]="isEditable"
                                    [(ngModel)]="containerObj.purpose"  [name]="'purpose'" [displayField]="'value'"
                                    [options]="containerPurposeList?.results" [errors]="errorObj.purpose">
                                </app-toggle-select>
                                <!-- (ngModelChange)="onPurposeChange($event)" -->
                            </div>

                            <ng-container *ngIf="(containerObj?.purpose?.dev_value === 'domestication' && containerObj?.ownership?.dev_value == 'own')" fxLayout="row"
                                          class="col2">
                                <!-- Post Assesment value -->
                                <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                                    <div class="inputTitle">
                                        <span>Assessment Value*</span>
                                    </div>
                                    <logzy-money-field [isEditable]="isEditable"
                                        [errors]="errorObj.assessment_value"  [(amount)]="containerObj.assessment_value"
                                        [(currencyCode)]="containerObj.assessment_value_currency">
                                    </logzy-money-field>
                                </div>


                                <!-- Post Location -->
                                <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                                        <div class="inputTitle">
                                            <span>Location*</span>
                                        </div>
                                    <app-mat-auto-search [isEditable]="isEditable" [(ngModel)]="containerObj.domesticated_at" [name]="'current_location'"
                                        [listUrl]="base_url+'?location_type_name=port&search=::search::'"
                                        [setSearchValue]="false" [displayField]="'name_display'" [idField]="null" [tooltipIcon]="true"
                                        [tooltipName]="portTooltip" [errors]="errorObj.domesticated_at" class="align-items-center">
                                    </app-mat-auto-search>
                                </div>


                                <!-- Post CHA/Agency Name -->
                                <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                                    <div class="inputTitle">
                                        <span>CHA/Agency Name*</span>
                                    </div>
                                    <app-text-field [isEditable]="isEditable" [(ngModel)]="containerObj.cha_agency_name"
                                    [name]="'cha_agency_name'" [errors]="errorObj.cha_agency_name">
                                    </app-text-field>
                                </div>


                                <!-- Post Custom Duty Charge -->
                                <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                                        <div class="inputTitle">
                                            <span> Custom Duty Charge*</span>
                                        </div>
                                        <logzy-money-field [isEditable]="isEditable"
                                            [errors]="errorObj.custom_duty_charge"  [(amount)]="containerObj.custom_duty_charge"
                                            [(currencyCode)]="containerObj.custom_duty_charge_currency">
                                        </logzy-money-field>
                                </div>

                                <!-- Post  Domestication Remarks -->

                                <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                                    <div class="inputTitle">
                                        <span>Domestication Remarks</span>
                                    </div>
                                    <app-text-field [isEditable]="isEditable" [(ngModel)]="containerObj.domestication_remarks"
                                    [name]="'domestication_remarks'" [errors]="errorObj.domestication_remarks" [isMultiline]="true">
                                    </app-text-field>
                               </div>
                            </ng-container>


                            <!-- Post Stock Owner -->
                            <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                                <div class="inputTitle">
                                    <span>Owner Company*</span>
                                </div>
                                <app-mat-auto-search [isEditable]="isEditable" [(ngModel)]="containerObj.stock_owner"
                                    [name]="'stock_owner'" [displayField]="'name'" [listUrl]="company_url"
                                    [tooltipIcon]="true" [tooltipName]="'Container is owned by'" [idField]="null"
                                    [errors]="errorObj.stock_owner" class="align-items-center">
                                </app-mat-auto-search>
                            </div>

                            <div fxFlex="100" fxLayout="row" [class.smartContainer]="!isEditable">
                                <div class="sToggle" fxFlex="100" fxFlex.gt-xs="14.8em">
                                    <mat-slide-toggle color="primary" [(ngModel)]="is_smart_device"
                                        [disabled]="!isEditable" (toggleChange)="is_smart_device=!is_smart_device ">
                                        Is this a smart container?
                                    </mat-slide-toggle>
                                </div>
                                <div class="smartdevice" [class]="'show'" *ngIf="is_smart_device==true">
                                    <!-- Post Device Name -->
                                    <app-mat-auto-search [isEditable]="isEditable" [placeholder]="'Device Name'"
                                        [name]="'device_name'" [(ngModel)]="containerObj.device_name"
                                        [displayField]="'device_name'" [setSearchValue]="true" [idField]="'device_name'"
                                        [listUrl]="container_url+'container_device/?device_name=::search::'"
                                        [errors]="errorObj.device_name" fxFlex="100" fxFlex.gt-xs="13.8em">
                                    </app-mat-auto-search>
                                    <!-- Post Device ID -->
                                    <app-text-field [isEditable]="isEditable" [placeholder]="'Device ID'"
                                        [(ngModel)]="containerObj.device_id" [name]="'device_id'"
                                        [errors]="errorObj.device_id" fxFlex="100" fxFlex.gt-xs="13.8em">
                                    </app-text-field>
                                </div>

                            </div>
                        </div>
                        <div class="btnb" fxFlex="100">
                            <button class="bck" mat-stroked-button (click)="backToList()">Back</button>
                            <button class="nxt" mat-stroked-button cdkStepperNext (click)="scrolltop();">Next</button>
                        </div>
                    </div>
                </div>
                <div *ngIf="bulk">
                    <div class="content form-group" id="card2" fxLayout="column wrap">
                        <div class="headContent fhc">
                            <span class="head"> <b> Download the format of excel file here </b></span> <img
                                class="format" src="assets/images/products/sheets.png" alt="Download Format"
                                (click)="export()">
                        </div>
                        <div class="formContent" fxLayout="column wrap">
                            <ul>
                                <li>Add the data in the excel format as per the required format:</li>
                                <li>Once you have downloaded the excel sheet, take the POL/PODS from the third tab (Port
                                    List) Please don’t enter the names yourself as that might not match master data.
                                </li>
                                <li>Put only the 1st leg slot. Put che charge name “I Leg Slot”.</li>
                                <li>Don’t put any special characters in the Term field e.g. if term is CY/CY then only
                                    mention CYCY.</li>
                                <li>Avoid putting any junk data/special characters in the excel sheet for the data read
                                    operation to work properly.</li>
                                <li>Make sure you are not adding a data which is duplicated in sheet already exists in
                                    the
                                    database</li>
                                <li>Do not change the column headings provided in the template. These need to be
                                    unchanged
                                    the import to work in the next step</li>
                            </ul>
                            <div class="quantity" fxLayout="row wrap">
                                <div fxFlex="100" fxFlex.gt-md="65%">
                                    <span> <b> Need more help?</b></span>
                                    <br>
                                    <span>Now, it’s easier than done. Help yourself the video tutorial</span><br>
                                    <span>Cheers!</span>
                                </div>
                                <div class="video" fxFlex.gt-md="35%">
                                    <iframe src="https://www.youtube.com/embed/4U5WBzqYbnc" title="YouTube video player"
                                        frameborder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowfullscreen></iframe>
                                </div>

                            </div>
                            <div class="btnb" fxFlex="100">
                                <button class="bck" mat-stroked-button
                                    routerLink="/dashboards/master-dashboard">Back</button>
                                <button type="submit" class="nxt" mat-stroked-button cdkStepperNext
                                    (click)="bulkUpload()">
                                    Continue</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </cdk-step>
        <cdk-step>
            <ng-template cdkStepLabel>Physical Characteristics</ng-template>
            <span class="containerNo">Container No: {{containerObj.container_number}}</span>
            <div class="proBg">
                <mat-progress-bar id="progressBar1" class="progressSlider" mode="determinate" value="{{counter1}}">
                </mat-progress-bar>
            </div>
            <div class="formLayout" *ngIf="showPC">
                <logzy-content-loader *ngIf="loader" [set2]="loader"></logzy-content-loader>
                <logzy-content-loader *ngIf="loader" [set2]="loader"></logzy-content-loader>
                <logzy-content-loader *ngIf="loader" [set2]="loader"></logzy-content-loader>
                <div class="content form-group" id="card4" fxLayout="column wrap" *ngIf="!loader">
                    <!-- <h6> -->
                    <!--     Container No: {{containerObj.container_number}} -->
                    <!-- </h6> -->
                    <div class="headContent fhc" fxFlex="100">
                        <h5>
                            Technical Specifications
                        </h5>
                    </div>
                    <div fxFlex="100" class="inputs inputMaxWidth" fxLayout="row wrap">
                        <!-- Post Max. Gross Weight in KGs-->
                        <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                            <div class="inputTitle">
                                <span>Max. Gross Weight</span>
                            </div>
                            <app-number-field [isEditable]="isEditable"
                                [(ngModel)]="containerObj.maximum_gross_weight_kg" [name]="'maximum_gross_weight_kg'"
                                [minValue]="0" [maxValue]="99999" [maxlength]="5"
                                [errors]="errorObj.maximum_gross_weight_kg" [numVal]="'KGs'">
                            </app-number-field>
                        </div>

                        <!-- Post Tare Weight in KGs-->
                        <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                            <div class="inputTitle">
                                <span>Tare Weight</span>
                            </div>
                            <app-number-field [isEditable]="isEditable" [(ngModel)]="containerObj.tare_weight_kg"
                                [name]="'tare_weight_kg'" [minValue]="0"
                                [maxValue]="containerObj.maximum_gross_weight_kg" [maxlength]="5"
                                [errors]="errorObj.tare_weight_kg" [numVal]="'KGs'">
                            </app-number-field>
                        </div>

                        <!-- Post Carrying Capacity in KGs-->
                        <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                            <div class="inputTitle">
                                <span>Payload (in KGs)</span>
                            </div>
                            <app-number-field [isEditable]="isEditable" [(ngModel)]="containerObj.capacity_kg"
                                [name]="'capacity_kg'" [minValue]="0" [maxValue]="99999" [maxlength]="5"
                                [errors]="errorObj.capacity_kg" [numVal]="'KGs'">
                            </app-number-field>
                        </div>

                        <!-- Post Allowable Stacking Weight in KGs-->
                        <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                            <div class="inputTitle">
                                <span>Allowable Stacking Weight</span>
                            </div>
                            <app-number-field [isEditable]="isEditable"
                                [(ngModel)]="containerObj.allowable_stacking_weight_kg"
                                [name]="'allowable_stacking_weight_kg'" [minValue]="0" [maxValue]="999999"
                                [maxlength]="6" [errors]="errorObj.allowable_stacking_weight_kg" [numVal]="'KGs'">
                            </app-number-field>
                        </div>

                        <!-- Post Racking Test Load Value in KGs-->
                        <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                            <div class="inputTitle">
                                <span>Racking Test Load Value</span>
                            </div>
                            <app-number-field [isEditable]="isEditable"
                                [(ngModel)]="containerObj.racking_test_load_value_kg"
                                [name]="'racking_test_load_value_kg'" [minValue]="0" [maxValue]="999999" [maxlength]="6"
                                [errors]="errorObj.racking_test_load_value_kg" [numVal]="'KGs'">
                            </app-number-field>
                        </div>
                    </div>
                </div>
                <div class="content form-group" id="card5" fxLayout="column wrap" *ngIf="!loader">
                    <div class="headContent fhc" fxFlex="100">
                        <!-- <h6> -->
                        <!--     Container No: {{containerObj.container_number}} -->
                        <!-- </h6> -->
                        <h5>
                            Physical Characteristics
                        </h5>
                    </div>
                    <div fxFlex="100" class="inputs inputMaxWidth" fxLayout="row wrap">
                        <!-- Post CSC Plate No -->
                        <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                            <div class="inputTitle">
                                <span>CSC Plate No</span>
                            </div>
                            <app-text-field [isEditable]="isEditable" [(ngModel)]="containerObj.csc_plate_number"
                                [name]="'csc_plate_number'" [errors]="errorObj.csc_plate_number">
                            </app-text-field>
                        </div>

                        <!-- Post Next Examination Date -->
                        <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                            <div class="inputTitle">
                                <span>Next Examination Due On</span>
                            </div>
                            <app-date-field [isEditable]="isEditable" [minDate]="currentDate"
                                [(ngModel)]="containerObj.next_examination_date" [name]="'next_examination_date'"
                                [errors]="errorObj.next_examination_date">
                            </app-date-field>
                        </div>

                        <!-- Post ACEP -->
                        <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                            <div class="inputTitle">
                                <span> ACEP</span>
                            </div>
                            <app-text-field [isEditable]="isEditable" [(ngModel)]="containerObj.acep" [name]="'acep'"
                                [errors]="errorObj.acep">
                            </app-text-field>
                        </div>

                        <!-- Post Remarks -->
                        <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                            <div class="inputTitle">
                                <span>CSC Remarks</span>
                            </div>
                            <app-text-field [isMultiline]="true" [isEditable]="isEditable"
                                [(ngModel)]="containerObj.csc_remark" [name]="'csc_remark'"
                                [errors]="errorObj.csc_remark">
                            </app-text-field>
                        </div>
                    </div>
                </div>
                <div class="content form-group" id="card6" fxLayout="column wrap" *ngIf="!loader">
                    <div class="headContent fhc" fxFlex="100">
                        <h5>
                            Build Details
                        </h5>
                    </div>
                    <div fxFlex="100" class="inputs inputMaxWidth" fxLayout="row wrap">
                        <!-- Post Manufacturing Date -->
                        <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                            <div class="inputTitle">
                                <span>Manufacturing Date</span>
                            </div>
                            <app-month-year-field [isEditable]="isEditable" [grade]="containerGrade"
                                [gradeLabel]="containerGradeObj?.name" [gradeColor]="containerGradeObj?.color"
                                [(ngModel)]="containerObj.manufacture_date" [name]="'manufacture_date'"
                                [isCurrentDate]="true" [errors]="errorObj.manufacture_date"
                                (ngModelChange)="checkContainerGrade($event)">
                            </app-month-year-field>
                        </div>

                        <!-- Post Manufacturer Name || Organization -->
                        <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                            <div class="inputTitle">
                                <span>Manufactured by</span>
                            </div>
                            <app-text-field [isEditable]="isEditable" [(ngModel)]="containerObj.manufactured_by"
                                [name]="'manufactured_by'" [errors]="errorObj.manufactured_by">
                            </app-text-field>
                        </div>

                        <!-- Post First EY at -->
                        <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                            <div class="inputTitle">
                                <span>{{containerEYLabel}}</span>
                            </div>
                            <app-mat-auto-search [isEditable]="isEditable" [(ngModel)]="containerObj.first_ey_depot"
                                (ngModelChange)="selectDepotForm($event)" [name]="'first_ey_depot'" [disabled]="disableCurrentLocation()"
                                [listUrl]="base_url+'?location_type_name=depot&name=::search::'" [setSearchValue]="true"
                                [displayField]="'name_display'" [idField]="null" [searchIcon]="true"
                                [tooltipIcon]="true" [tooltipName]="EYTooltip" [labelItemTemplate]="depotSelectedItem"
                                [itemTemplate]="depotItem" [errors]="errorObj.first_ey_depot">
                                <!-- [displayTemplate]="leaseDisplayItem" -->
                            </app-mat-auto-search>
                        </div>

                        <!-- Post First EY Date -->
                        <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                            <div class="inputTitle">
                                <span>{{containerEYDateLabel}}</span>
                            </div>
                            <app-date-field [isEditable]="isEditable" [(ngModel)]="containerObj.first_ey_date"
                                [name]="'first_ey_date'" [maxDate]="currentDate" [tooltipIcon]="true"
                                [disabled]="disableCurrentLocation()" [tooltipName]="EYDateTooltip" [errors]="errorObj.first_ey_date">
                            </app-date-field>
                        </div>

                        <!-- Post Port Name -->
                        <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                            <div class="inputTitle">
                                <span>Current Location</span>
                            </div>
                            <app-mat-auto-search [isEditable]="isEditable" [(ngModel)]="containerObj.current_location"
                                [name]="'current_location'" [disabled]="disableCurrentLocation()"
                                [listUrl]="base_url+'?location_type_name=depot&search=::search::'"
                                [setSearchValue]="false" [displayField]="'name_display'" [idField]="null"
                                [tooltipIcon]="true" [tooltipName]="portTooltip" [errors]="errorObj.current_location">
                            </app-mat-auto-search>
                        </div>
                    </div>
                    <div class="btnb" fxFlex="100">
                        <button class="bck" mat-stroked-button cdkStepperPrevious>Back</button>
                        <button class="nxt" mat-stroked-button cdkStepperNext (click)="scrolltop1()">Next</button>
                    </div>
                </div>
            </div>
            <ng-container *ngIf="showBulk">
                <div class="content form-group" id="card4" fxLayout="column wrap">
                    <div class="headContent fhc">
                        <span class="head"><b> Upload Data</b> </span>
                    </div>
                    <bulk-data></bulk-data>
                    <div class="btnb1" fxFlex="100">
                        <button class="bck" mat-raised-button cdkStepperPrevious class="bck">Back</button>
                        <button class="nxt" mat-stroked-button cdkStepperNext (click)="saveUpload()">Save
                            Upload</button>
                    </div>
                </div>
            </ng-container>
        </cdk-step>
        <cdk-step>
            <ng-template cdkStepLabel>Documents </ng-template>
            <span class="containerNo">Container No: {{containerObj.container_number}}</span>
            <div class="formLayout" *ngIf="showDoc">
                <logzy-content-loader *ngIf="loader" [set2]="loader"></logzy-content-loader>
                <logzy-content-loader *ngIf="loader" [set2]="loader"></logzy-content-loader>
                <logzy-content-loader *ngIf="loader" [set2]="loader"></logzy-content-loader>
                <div class="content form-group" fxLayout="column wrap" *ngIf="!loader">
                    <app-remarks fxLayout="row wrap" [isEditable]="isEditable" [placeholder]="'Enter your remark here.'"
                        [(ngModel)]="containerObj.remarks" [commentDate]="containerObj.updated_at"
                        [updatedBy]="containerObj.updated_by">
                    </app-remarks>
                </div>
                <div class="content form-group" id="card7" fxLayout="column wrap" *ngIf="!loader">
                    <div class="headContent fhc" fxFlex="100">
                        <h5>
                            Container Photos
                        </h5>
                    </div>
                    <div fxFlex="100" class="inputs" fxLayout="row wrap">
                        <small [class.uploadInfoText]="uploadedImage" *ngIf="containerObj?.photos.length && isEditable">
                            Please select one image as the default container image.
                        </small>
                        <div class="choose" fxFlex="100" *ngIf="isEditable" fxLayout="row wrap">
                            <mat-radio-group color="primary" [ngModel]="containerObj.default_photo"
                                (ngModelChange)="sortContainerObjPhotos($event)" fxLayout="row wrap">
                                <ng-container *ngFor="let photo of containerObj.photos">
                                    <mat-radio-button [value]="photo">
                                        <div class="product_img">
                                            <img [src]="photo?.document_file">
                                        </div>
                                    </mat-radio-button>
                                    <div class="delete_icon">
                                        <i class="flaticon-delete" (click)="deleteUploadImg(photo)"></i>
                                    </div>
                                </ng-container>
                            </mat-radio-group>
                        </div>
                        <div class="choose" fxFlex="100" *ngIf="!isEditable">
                            <div class="showPic">
                                <span *ngIf="!projectPhoto && !containerObj?.photos" fxFlex="100"> Click on below
                                    photos to view here.</span>
                                <span *ngIf="!projectPhoto && containerObj?.photos" fxFlex="100"> No photo
                                    available.</span>
                                <img *ngIf="projectPhoto" [src]="projectPhoto" fxFlex="100">
                                <i *ngIf="projectPhoto==containerObj?.default_photo?.document_file && projectPhoto"
                                    class="flaticon-ribbon"></i>
                            </div>
                            <div class="restPhotos" color="primary">
                                <ng-container *ngFor="let photo of containerObj?.photos, let idx=index">
                                    <div *ngIf="containerObj?.photos[idx].id==containerObj?.default_photo?.id">
                                        <!-- this show default pic -->
                                        <div class="product_img" fxFlex="100" fxLayout="row wrap"
                                            (click)="project(containerObj?.photos[idx]?.document_file,'default')">
                                            <i class="flaticon-ribbon"></i>
                                            <img [src]="containerObj?.photos[idx]?.document_file" fxFlex="100">
                                        </div>
                                    </div>
                                    <div *ngIf="containerObj?.photos[idx].id!=containerObj?.default_photo?.id">
                                        <!-- this is rest photos -->
                                        <div class="product_img" fxFlex="100" fxLayout="row wrap"
                                            (click)="project(containerObj?.photos[idx]?.document_file,'rest')">
                                            <img [src]="containerObj?.photos[idx]?.document_file" fxFlex="100">
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                        <div class="uploadBtn" fxFlex="100" *ngIf="isEditable" fxLayout="row">
                            <app-file-field [showUploadedList]="false" [fileDropArea]="false" [isEditable]="isEditable"
                                [(ngModel)]="containerObj.photos" [documentTypeGroup]="'container_pic'" name="photos"
                                label="Upload Photos" (click)="showUploadInfo()">
                            </app-file-field>
                        </div>
                    </div>
                </div>
                <div class="content form-group" id="card8" fxLayout="column wrap" *ngIf="!loader">
                    <div class="headContent fhc" fxFlex="100">
                        <h5>
                            Documents
                        </h5>
                    </div>
                    <div class="doc_details" fxFlex="100" fxLayout="row wrap">
                        <div fxFlex="100" fxLayout="column">
                            <app-file-field [isEditable]="isEditable" [(ngModel)]="containerObj.documents"
                                [dotFloating]="true" [documentTypeGroup]="'container'" [name]="'documents'"
                                fxLayout="row wrap">
                            </app-file-field>
                        </div>
                    </div>
                    <div class="btnb" fxFlex="100">
                        <button class="bck" mat-stroked-button cdkStepperPrevious>Back</button>
                        <button *ngIf="containerObj.id==null" type="submit" mat-stroked-button class="nxt"
                            (click)="review()">{{containerObj.id==null?'Review':'Save'}}
                        </button>
                        <button *ngIf="containerObj.id!=null" mat-raised-button class="save" mat-dialog-close
                            cdkFocusInitial routerLink="/dashboards/master-dashboard">Back to Main page</button>
                    </div>
                </div>
            </div>
            <ng-container *ngIf="showReview">
                <div class="review" fxLayout="row wrap">
                    <div class="dailogHead" fxFlex="100">
                        <h4 mat-dialog-title>Review Data</h4>
                    </div>
                    <div class="dailogData" fxFlex="50" fxLayout="row wrap">
                        <div fxFlex="100" fxFlex.gt-md="50%" fxLayout="column">
                            <span class="dataTitle">Container number</span>
                            <span class="data">{{containerObj?.container_number}}</span>
                        </div>
                        <div fxFlex="100" fxFlex.gt-md="50%" fxLayout="column">
                            <span class="dataTitle">Size type</span>
                            <span class="data">{{containerSizeType?.display}}</span>
                        </div>
                        <div fxFlex="100" fxFlex.gt-md="50%" fxLayout="column">
                            <span class="dataTitle">Condition</span>
                            <span class="data">{{containerObj?.condition?.value}}</span>
                        </div>
                        <div fxFlex="100" fxFlex.gt-md="50%" fxLayout="column">
                            <span class="dataTitle">Purpose</span>
                            <span class="data">{{containerObj?.purpose?.value}}</span>
                        </div>

                        <div fxFlex="100" fxFlex.gt-md="50%" fxLayout="column"
                            *ngIf="containerObj?.maximum_gross_weight_kg!=null">
                            <span class="dataTitle">Max. Gross Weight (in KGs)</span>
                            <span class="data">{{containerObj?.maximum_gross_weight_kg}}</span>
                        </div>
                        <div fxFlex="100" fxFlex.gt-md="50%" fxLayout="column"
                            *ngIf="containerObj?.tare_weight_kg!=null">
                            <span class="dataTitle">Tare Weight (in KGs)</span>
                            <span class="data">{{containerObj?.tare_weight_kg}}</span>
                        </div>
                        <div fxFlex="100" fxFlex.gt-md="50%" fxLayout="column"
                            *ngIf="containerObj?.allowable_stacking_weight_kg!=null">
                            <span class="dataTitle">Allowable Stacking Weight</span>
                            <span class="data">{{containerObj?.allowable_stacking_weight_kg}}</span>
                        </div>
                        <div fxFlex="100" fxFlex.gt-md="50%" fxLayout="column"
                            *ngIf="containerObj?.racking_test_load_value_kg!=null">
                            <span class="dataTitle">Racking Test Load Value</span>
                            <span class="data">{{containerObj?.racking_test_load_value_kg}}</span>
                        </div>
                        <div fxFlex="100" fxFlex.gt-md="50%" fxLayout="column"
                            *ngIf="containerObj?.csc_plate_number!=null">
                            <span class="dataTitle">CSC Plate No</span>
                            <span class="data">{{containerObj?.csc_plate_number}}</span>
                        </div>
                        <div fxFlex="100" fxFlex.gt-md="50%" fxLayout="column"
                            *ngIf="containerObj?.next_examination_date!=null">
                            <span class="dataTitle">Next Examination </span>
                            <span class="data">{{containerObj?.next_examination_date | date:"dd MMM, yyyy"}}
                            </span>
                        </div>

                        <div fxFlex="100" fxFlex.gt-md="50%" fxLayout="column" *ngIf="containerObj?.acep!=null">
                            <span class="dataTitle">ACEP</span>
                            <span class="data">{{containerObj?.acep}}</span>
                        </div>
                        <div fxFlex="100" fxFlex.gt-md="50%" fxLayout="column" *ngIf="containerObj?.csc_remark!=null">
                            <span class="dataTitle">Remarks</span>
                            <span class="data">{{containerObj?.csc_remark}}</span>
                        </div>
                        <div fxFlex="100" fxFlex.gt-md="50%" fxLayout="column" [hidden]="!is_smart_device">
                            <span class="dataTitle">Device Name</span>
                            <span class="data">{{containerObj?.device_name}}</span>
                        </div>
                        <div fxFlex="100" fxFlex.gt-md="50%" fxLayout="column" [hidden]="!is_smart_device">
                            <span class="dataTitle">Device ID</span>
                            <span class="data">{{containerObj?.device_id}}</span>
                        </div>
                    </div>
                    <div class="dailogImage" fxFlex="50" fxLayout="row wrap`">
                        <div class="image" fxFlex="100" fxLayout="row wrap">
                            <div class="product_img" fxFlex="46" *ngFor="let photo of containerPhotos; index as i">
                                <img [src]="photo?.document_file" [class.defaultImg]="i==0" alt="">
                                <i class="flaticon-ribbon" *ngIf="i==0"></i>
                            </div>
                        </div>
                        <div>
                            <div class="map" fxFlex="100">
                                <img src="assets/images/products/Port.PNG" alt="">
                            </div>
                        </div>

                    </div>
                    <div mat-dialog-actions fxFlex="100">
                        <button mat-raised-button class="bck" (click)="docs()">Back</button>
                        <button mat-raised-button class="save" mat-dialog-close cdkFocusInitial
                            (click)="postContainer()">Save</button>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="showCmplt">
                <div class="content form-group" id="card7" fxFlayout="column">
                    <div class="bgImg" fxFlex="36.85em">
                        <img id="complete" src="assets/images/backgrounds/container_save_success.png" alt="">
                    </div>
                    <div class="cmpltTxt" fxFlex="100">
                        <div>
                            <span>Container Number: <mat-chip>{{containerObj.container_number}}</mat-chip> saved
                                successfully.</span>
                        </div>
                    </div>
                    <div class="btn" fxFlex="100">

                        <button mat-stroked-button class="nxt" (click)="goToList()">
                            <div>
                                <mat-icon MatSuffix aria-hidden="false" aria-label="Example home icon">dashboard
                                </mat-icon>
                                <span>Go to List </span>
                            </div>
                        </button>
                        <button mat-stroked-button class="nxt" (click)="goToAddNewContainer()">
                            <div>
                                <i MatSuffix id="i1" class="flaticon-container-solid"></i>
                                <span>Add a Container </span>
                            </div>
                        </button>
                    </div>
                </div>
            </ng-container>
        </cdk-step>
    </div>
    <cdk-step #fourthStep>
        <ng-template cdkStepLabel>Lifecycle Details</ng-template>
        <span class="containerNo">Container No: {{containerObj.container_number}}</span>
        <div class="content form-group" id="" fxLayout="column wrap" *ngIf="containerObj.id!=null">
            <app-life-cycle fxLayout="row wrap" [(isEditable)]="isEditable" (lifeCycleCount)="getLifeCycleCount($event)" [containerObj]="containerObj"></app-life-cycle>
        </div>
    </cdk-step>

</cdk-custom-stepper>

<!-- Lease template for dropdown -->
<ng-template #leaseItem let-item let-index>
    <div fxFlex="100" fxLayout="column" class="leaseListShow">
        <span class="leaseNumber">
            {{item?.agreement_number}}
        </span>
        <span class="companyName">
            {{item?.lessor_company_name}}
        </span>
    </div>
</ng-template>

<ng-template #leaseSelectedItem let-item>
    {{item?.agreement_number}}
</ng-template>

<ng-template #leaseDisplayItem let-item>
    {{item?.agreement_number}}<br>
    <small>{{item?.lessor_company_name}}</small>
</ng-template>

<!-- Purchase Order Number (PO Number) template for dropdown -->
<ng-template #poItem let-item let-index>
    <div fxFlex="100" fxLayout="column" class="leaseListShow">
        <span class="leaseNumber">
            {{item?.request_number}}
        </span>
        <span class="companyName">
            {{item?.requestor?.company?.legal_name}}<br>
            {{item?.latest_quote?.quote_items[0]?.container_size_type?.display}} <ng-container
                *ngIf="item?.latest_quote?.quote_items.length > 1">+ {{item?.latest_quote?.quote_items.length-1}}
                More</ng-container>
        </span>
    </div>
</ng-template>

<ng-template #poSelectedItem let-item>
    {{item?.request_number}}
</ng-template>

<ng-template #poDisplayItem let-item>
    {{item?.request_number}}<br>
    <small>{{item?.requestor?.company?.legal_name}}</small>
</ng-template>

<!-- //template for Depot -->
<ng-template #depotItem let-item let-index>
    <div fxFlex="100" fxLayout="column" class="managerListShow">
        <span class="fullname">
            {{ item?.name_display }}
        </span>
        <span class="email">
            {{ item?.address }}
        </span>
    </div>
</ng-template>

<ng-template #depotSelectedItem let-item>
    {{ item?.name_display }}
</ng-template>

<!-- Size Type template for dropdown -->
<ng-template #sizeTypeItem let-item let-index>
    <span>{{item?.container_size_type?.display}}</span>
</ng-template>

<ng-template #sizeTypeSelectedItem let-item>
    {{item?.container_size_type?.display}}
</ng-template>

<ng-template #sizeTypeDisplayItem let-item>
    {{item?.container_size_type?.display}}
</ng-template>
